import selectors from 'modules/ATS/selector.js'
import { connect } from 'react-redux'
import TPODashboard from '..'
import {
  exportCandidate,
  exportCSV,
  getCorporateData,
  getDegreeList,
  getDepartmentList,
  getDomainList,
  getEligibilityCriteriaQualification,
  getExportFiledData,
  getInstituteData,
  getJobRoleList,
  getRoleFilter,
  getScheduleFilter,
  getStatusFilter,
} from '../../JobRoles/actions'

import authSelector from 'modules/Auth/selectors'
import { getJobCategory } from '../../JobRoles/NewJobRole/actions'
import {
  getActiveJobRoles,
  getCTCAnalysis,
  getInstituteDetailsFromCampusId,
  getJobProfileStatus,
  getStudentPlacement,
  getYear,
  setFilteredDashboardDetails,
} from '../../TPODashboard/action'
import tpoSelectors from '../selectors'

import { getTPOMetrics } from 'modules/TPORequests/actions'

import { getSpecializationList, getTpoPrimaryCardData } from '../action'

import tpoRequestSelectors from '../../TPORequests/selectors'

const mapStateToProps = state => ({
  roundData: selectors.getRoundData(state),
  updateRoundData: selectors.updatedRoundData(state),
  instituteTokenCampusId: state.auth.instituteDetails.id,
  filteredDashboardDetails: tpoSelectors.getFilteredDashboardDetails(state),
  dashboardDetails: tpoSelectors.getDashboardDetails(state),
  tpoMetrics: tpoRequestSelectors?.getTpoMetricsData(state),
  userData: authSelector?.getUserInfo(state),
})

const mapDispatchToProps = {
  getJobRoleList,
  getCorporateData,
  getInstituteData,
  exportCandidate,
  getExportFiledData,
  getDepartmentList,
  getDegreeList,
  getDomainList,
  getRoleFilter,
  getStatusFilter,
  getScheduleFilter,
  getYear,
  getEligibilityCriteriaQualification,
  exportCSV,
  getJobCategory,
  getTpoPrimaryCardData,
  getSpecializationList,
  setFilteredDashboardDetails,
  getInstituteDetailsFromCampusId,
  getTPOMetrics,
  getJobProfileStatus,
  getCTCAnalysis,
  getActiveJobRoles,
  getStudentPlacement,
}

export default connect(mapStateToProps, mapDispatchToProps)(TPODashboard)
